export default __webpack_public_path__ + "static/media/values.51ce33b4.png";